module.exports = __webpack_public_path__ + "img/mail.60d46708.png";